import { IAjaxConfig } from '../helpers';
/**
 *  活动内容 API 地址
 *  测试环境API链接结构
格式：https://tst-bpcentral.lenovo.com.cn/api/{app-name}/{service-name}/{service-uri}
示例：https://tst-bpcentral.lenovo.com.cn/api/bpportal-mall/bpportal-mall-order-sit/managerorder/order/kuaiDi100LogisticsInformation/wrtt
 */
export class EnumApiContent {
  /**
   * @des 广告
   */
  readonly content_ads: IAjaxConfig = {
    url: '/api/gateway/content-bff/public/v1/ad/info/currentByAdSpace/{sign}',
    // cache: false,
    // awaitAuthenticated: false,
    fos: true,
  };
  /**
   * @des 直播活动
   */
  readonly content_live_activity: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/public/v2/activity/info/liveStreamingList',
    method: 'post',
    fos: true,
  };
  /**
   * @des 促销活动
   */
  readonly content_promotion_activity: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/public/v2/activity/info/listForPage',
    method: 'post',
    fos: true,
  };
  /**
   * @des 直播活动 详情
   */
  readonly content_live_details: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/public/v2/activity/decoration/{activityId}',
  };
  /**
   * @des 直播活动 详情 商品
   */
  readonly content_live_product: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/v2/activity/info/findProductList',
    method: 'post',
  };
  /**
   * @des 直播活动 详情 海报
   */
  readonly content_live_posters: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/public/v2/activity/info/listActivityPoster',
    method: 'post',
  };
  /**
   * @des 直播活动 详情 海报下载
   */
  readonly content_live_posters_down: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/activity/info/genPromotionAttachment/{id}',
  };
  /**
   * @des 直播活动 详情 太阳码下载
   */
  readonly content_live_posters_qrCodeDown: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/activity/info/genPromotionCode4Poster/{id}',
  };
  /**
   * @des 直播活动  推过码解密
   */
  readonly content_live_scene: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/promotion/scene/{id}',
  };
  /**
   * @des 直播活动  推广记录器
   */
  readonly content_live_record: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/public/v1/promotion/record',
    method: 'post',
  };
  /**
   * @des 推广记录器（新）
   */
  readonly content_live_recordV2: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/public/v1/promotion/recordV2',
    method: 'post',
  };
  /**
   * @des 生成分享码
   */
  readonly content_share_code: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/share/code/day/gen',
    method: 'post',
    cache: true,
  };
  /**
   * @des 直播活动  进入直播间统计
   */
  readonly content_live_statistics: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/activity/statistics/accessLiveBroadcastingRoom',
    method: 'post',
  };
  /**
   * @des 用户反馈类型
   */
  readonly content_feekback_type: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/user/feedback/dropdown/feekbackType',
    awaitAuthenticated: false,
  };
  /**
   * @des 用户反馈提交
   */
  readonly content_feekback_save: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/user/feedback/save',
    loading: true,
  };
  /**
   * @des 弹屏
   */
  readonly content_screen_ads: IAjaxConfig = {
    url: '/api/gateway/content-bff/public/v1/screen/list',
    method: 'post',
    fos: true,
  };
  /**
   * @des 我的海报 活动海报
   */
  readonly content_activity_myposters: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/v2/activity/info/listPersonalTopicActivity',
    method: 'post',
  };
  /**
   * @des 我的海报 推广海报
   */
  readonly content_promote_myposters: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/v2/stuff/poster/listPersonalTopicPoster',
    method: 'post',
  };
  /**
   * @des 我的海报 海报详情
   */
  readonly content_detail_myposters: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/promotion/poster/listByPromoId',
    method: 'post',
  };
  /**
   * @des isg推广活动 活动报名
   */
  readonly content_isg_signUp: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/v2/activity/enroll/{activityId}',
    method: 'post',
  };
  /**
   * @des isg推广活动 取消活动
   */
  readonly content_isg_cancel_signUp: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/v2/activity/enroll/{activityId}',
    method: 'delete',
  };
  /**
   * @des isg推广活动：是否已报名
   */
  readonly content_isg_activity_enroll: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/public/v2/activity/enroll/{activityId}',
  };
  /**
   * @des isg推广活动：立即参与信息
   */
  readonly content_isg_participation_info: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-activity-bff/v1/bff/content/activity/info/findParticipationLink/{activityId}',
  };
  /**
   * @des 留资：分页查询留资信息
   */
  readonly content_isg_retaincapital_list: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/lead-contact/list-page',
    method: 'post',
  };
  /**
   * @des 留资：导出留资
   */
  readonly content_isg_retaincapital_export: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/lead-contact/export',
    method: 'post',
  };
  /**
   * @des 留资：修改跟踪状态
   */
  readonly content_isg_retaincapital_update_status: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/lead-contact/follow-status',
    method: 'put',
  };
  /**
   * @des 留资：提交留资
   */
  readonly content_isg_retaincapital_save: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/lead-contact',
    method: 'post',
  };
  /**
   * @des 名片：查询名片信息
   */
  readonly content_isg_card_get_info: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/business-card',
    method: 'get',
  };
  /**
   * @des 名片：保存名片信息
   */
  readonly content_isg_card_save_info: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/business-card',
    method: 'post',
  };
  /**
   * @des 名片：关闭名片信息
   */
  readonly content_isg_card_close_info: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/business-card',
    method: 'delete',
  };
  /**
   * @des 名片：第三方查看名片
   */
  readonly content_isg_card_third_info: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/public/v1/bff/content/business-card/third-party',
    method: 'get',
  };
  /**
   * @des 获取海报回流次数
   */
  readonly content_poster_shareLog: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/report/shareLog/countByPosterId/{id}',
    method: 'get',
  };
  /**
   * @des 获取海报活动回流次数
   */
  readonly content_poster_activity_shareLog: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/report/shareLog/countByPromotionId/{id}',
    method: 'get',
  };
  /**
   * @des 根据token查询授权牌用户信息
   */
  readonly content_license_user_token: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/license/user/token',
    method: 'get',
    loading: false,
  };
  /**
   * @des 授权牌记录保存
   */
  readonly content_license_record_save: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/license/record/save',
    method: 'post',
  };

  /**
   * @des 优秀合作案例 页面list
   */
  readonly content_goodcase_pagelist: IAjaxConfig = {
    // url: '/api/gateway/content-bff/v2/news/list',
    url: '/api/gateway/content-bff/v2/news/list',
    method: 'post',
    loading: true,
    fos: true,
  };

  /**
   * @des 优秀合作案例 标签list
   */
  readonly content_goodcase_labellist: IAjaxConfig = {
    // url: '/api/gateway/content-bff/v2/news/list',
    url: '/api/gateway/content-bff/v1/content/label/getContentLabelList',
    method: 'get',
    cache: true,
  };

  /**
   * @des 优秀合作案例 查看详情
   */
  readonly content_goodcase_detail: IAjaxConfig = {
    url: '/api/gateway/content-bff/v2/news/{id}',
    method: 'get',
    loading: true,
    fos: true,
  };

  /**
   * @des 合作伙伴-留资 提交
   */
  readonly content_staydata_save: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/leave/contact/save',
    method: 'post',
    loading: true,
  };

  /**
   * @des 合作伙伴-查询
   */
  readonly content_coop_search: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/partner/list',
    method: 'post',
    loading: true,
  };

  /**
   * @des PC验证是否需要新手引导
   */
  readonly content_guide_check: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/guide/record/check',
    method: 'get',
    loading: true,
  };

  /**
   * @des PC获取新手引导pdf链接
   */
  readonly content_guide_pdf: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/guide/record/downloadUrl',
    method: 'get',
    loading: true,
  };

  /**
   * @des PC获取配置工具权限
   */
  readonly content_configTool_userGroup: IAjaxConfig = {
    url: '/api/gateway/content-bff/isExist/configTool/userGroup',
    method: 'get',
    loading: true,
  };

  /**
   * @des 内容中心 获取特赞token
   */
  readonly content_resource_tezign_token: IAjaxConfig = {
    url: '/api/gateway/content-bff/resource/tezign/token',
    method: 'get',
    loading: false,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  /**
   * @des 内容中心 筛选 背景banner
   */
  readonly content_resource_banner: IAjaxConfig = {
    url: '/api/gateway/content-bff/resource/banner',
    method: 'get',
    loading: true,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  /**
   * @des 内容中心 筛选 系列
   */
  readonly content_resource_serial: IAjaxConfig = {
    url: '/api/gateway/content-bff/resource/serial',
    method: 'get',
    loading: true,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  /**
   * @des 内容中心 列表
   */
  readonly content_resource_list: IAjaxConfig = {
    url: '/api/gateway/content-bff/resource/list',
    method: 'get',
    loading: true,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  /**
   * @dec 内容中心获取详情
   */
  readonly content_resource_center_details: IAjaxConfig = {
    url: '/api/gateway/content-bff/resource/center/info',
    method: 'get',
    loading: true,
    headers: {
      'Content-Type': 'application/json',
    },
    // awaitAuthenticated: false,
  };
  /**
   * @dec 内容中心 详情 图片、视频、文章列表
   */
  readonly content_resource_center_list: IAjaxConfig = {
    url: '/api/gateway/content-bff/resource/center/list',
    method: 'post',
    loading: true,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  /**
   * @dec 内容中心 文章详情
   */
  readonly content_resource_center_article: IAjaxConfig = {
    url: '/api/gateway/content-bff/resource/center/article',
    method: 'get',
    loading: true,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  /**
   * @dec 上传图片
   */
  readonly content_upload_img: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/v1/file/uploadPic',
    method: 'post',
    loading: true,
  };
}
